import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { useMemo } from "react";
import { ExperiencesCategoryView } from "@/lib/features/ExperiencesCategoryView";
import { trpc } from "@/router";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/upplevelser/kategori/$slug")({
  component: CategoryRoute
});
function CategoryRoute() {
  const $ = _c(11);
  const {
    slug
  } = Route.useParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = trpc.experiences.categories.all.queryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: categories
  } = useQuery(t0);
  let t1;
  if ($[1] !== categories || $[2] !== slug) {
    t1 = categories?.find(cat => cat.slug === slug);
    $[1] = categories;
    $[2] = slug;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const category = t1;
  let t2;
  if ($[4] !== category?.id) {
    t2 = trpc.experiences.public.queryOptions({
      categoryId: category?.id ?? null
    });
    $[4] = category?.id;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: experiences
  } = useQuery(t2);
  if (!category) {
    throw notFound();
  }
  let t3;
  if ($[6] !== experiences) {
    t3 = experiences ?? [];
    $[6] = experiences;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== category.name || $[9] !== t3) {
    t4 = /*#__PURE__*/_jsx(ExperiencesCategoryView, {
      experiences: t3,
      categoryName: category.name
    });
    $[8] = category.name;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}